import React, { useContext, useEffect, useMemo } from "react";
import { generateKey } from "../../../shared/utils";
import AccordionContext from "../context";
export var Item = function Item(_ref) {
  var e = _ref.children,
      _ref$defaultOpen = _ref.defaultOpen,
      t = _ref$defaultOpen === void 0 ? !1 : _ref$defaultOpen,
      o = _ref.id,
      n = _ref.className;
  var c;

  var _useContext = useContext(AccordionContext),
      a = _useContext.openElement,
      r = useMemo(function () {
    return generateKey();
  }, []);

  return useEffect(function () {
    t && a(r);
  }, [r]), React.createElement(React.Fragment, null, null === (c = null == React ? void 0 : React.Children) || void 0 === c ? void 0 : c.map(e, function (e) {
    return React.cloneElement(e, {
      uid: o || r,
      className: n
    });
  }));
};
export default React.memo(Item);